import { Div, Input, Switch, Text } from '@pinpoint/design-kit';
import React from 'react';
import PropTypes from 'prop-types';
import { noOp } from 'src/functions';

export function Toggles({ airToggle, toggleAir, statToggle, toggleStat, pricingToggle, togglePricing, hasPricing }) {
  const pricingInactiveColor = hasPricing ? 'shade66' : 'shadeBD';
  const pricingTextInactiveColor = hasPricing ? 'shade4F' : 'shadeBD';
  return (
    <Div d="flex" align="flex-start">
      {![null, undefined].includes(airToggle) && (
        <Div d="flex" align="center" onClick={toggleAir}>
          <Text textColor={airToggle ? 'shade66' : 'shade4F'}>Adverse Impact Ratio (AIR)</Text>
          <Switch
            checked={airToggle}
            activeShadow="0"
            m={{ x: '1rem' }}
            activeColor="shade66"
            inactiveColor="shade66"
          />
          <Text textColor={airToggle ? 'shade4F' : 'shade66'}>Values</Text>
        </Div>
      )}
      {![null, undefined].includes(statToggle) && (
        <Div
          d="flex"
          align="center"
          onClick={!airToggle ? noOp : toggleStat}
          m={![null, undefined].includes(airToggle) ? { l: '3rem' } : '0px'}
        >
          <Text textColor={statToggle ? 'shade66' : 'shade4F'}>Average</Text>
          <Switch
            checked={statToggle}
            activeShadow="0"
            m={{ x: '1rem' }}
            activeColor="shade66"
            inactiveColor="shade66"
          />
          <Text textColor={statToggle ? 'shade4F' : 'shade66'}>Median</Text>
        </Div>
      )}
      <Div flexGrow="1" />
      {![null, undefined].includes(pricingToggle) && (
        <Div d="flex" align="center" onClick={hasPricing ? togglePricing : noOp} m={{ l: '3rem' }}>
          <Text textColor={pricingToggle ? pricingInactiveColor : pricingTextInactiveColor}>Model results</Text>
          <Switch
            disable
            checked={pricingToggle}
            activeShadow="0"
            m={{ x: '1rem' }}
            activeColor="marigold"
            inactiveColor={pricingInactiveColor}
          />
          <Text textColor={pricingToggle ? 'marigold' : pricingInactiveColor}>With pricing</Text>
        </Div>
      )}
    </Div>
  );
}

Toggles.defaultProps = {
  toggleAir: noOp,
  toggleStat: noOp,
  togglePricing: noOp,
};

Toggles.propTypes = {
  airToggle: PropTypes.oneOf([true, false, null, undefined]).isRequired,
  statToggle: PropTypes.oneOf([true, false, null, undefined]).isRequired,
  pricingToggle: PropTypes.oneOf([true, false, null, undefined]).isRequired,
  hasPricing: PropTypes.oneOf([true, false]).isRequired,
  toggleAir: PropTypes.func,
  toggleStat: PropTypes.func,
  togglePricing: PropTypes.func,
};

export function MinAIRInput({ value, onChange }) {
  return (
    <Input
      id="min-val"
      type="number"
      step="0.01"
      min="0"
      placeholder="0.0"
      max="1"
      value={value}
      onChange={onChange}
      textWeight="550"
      w="4.5rem"
      m={{ y: '0', x: '.5rem' }}
      borderColor="shade79"
      h="1.875rem"
      style={{ color: '#333333' }}
    />
  );
}

MinAIRInput.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
};

MinAIRInput.defaultProps = {
  value: 0.83,
  onChange: noOp,
};

export function MaxAIRInput({ value, onChange }) {
  return (
    <Input
      id="max-val"
      type="number"
      step="0.01"
      placeholder="1.0"
      value={value}
      onChange={onChange}
      min="1"
      textWeight="550"
      borderColor="shade79"
      m={{ y: '0', l: '.5rem', r: '1rem' }}
      h="1.875rem"
      w="4.5rem"
      style={{ color: '#333333' }}
    />
  );
}

MaxAIRInput.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
};

MaxAIRInput.defaultProps = {
  value: 1.2,
  onChange: noOp,
};
